import { render, staticRenderFns } from "./vipNav.vue?vue&type=template&id=6d415612&scoped=true&"
import script from "./vipNav.vue?vue&type=script&lang=ts&"
export * from "./vipNav.vue?vue&type=script&lang=ts&"
import style0 from "./vipNav.scss?vue&type=style&index=0&id=6d415612&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d415612",
  null
  
)

export default component.exports